import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "cambiaLabelCampo",
})
export class LabelStoricoPipe implements PipeTransform {
  mappaValori: Map<string, string> = new Map([
    ["/datiPrivacy/datiPersonali", "Presenza dati personali"],
    ["/datiPrivacy/datiGiudiziari", "Presenza dati giudiziari"],
    ["/datiPrivacy/datiSensibili", "Presenza dati sensibili"],
    ["/datiPrivacy/privato", "Livello di consultabilità"],
    ["/datiPrivacy/motivoRestrizioni", "Motivo restrizioni"],
    ["/primario/datiPrivacy/condizioniRiproduzione", "Condizioni riproduzione"],
    [
      "/primario/datiPrivacy/condizioniConsultazione",
      "Condizioni consultazione",
    ],
    [
      "/primario/datiPrivacy/condizioniConsultazione",
      "Condizioni consultazione",
    ],
  ]);

  transform(value: string): any {
    if (this.mappaValori.get(value)) {
      return this.mappaValori.get(value);
    } else if (
      value.includes("/procedimentiAmministrativiAssociati/responsabile")
    ) {
      return "Responsabile procedimento " + value.split("/")[3];
    } else {
      return value;
    }
  }
}
